<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer008" role="doc-toc">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/One#_idTextAnchor000">Chapter One</a></p>
<p class="TOCitem"><a href="#/Two#_idTextAnchor001">Chapter Two</a></p>
<p class="TOCitem"><span href="#/Three#_idTextAnchor002" title="Link target outside of Sample">Chapter Three</span></p>
<p class="TOCitem"><span href="#/Four#_idTextAnchor003" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOCitem"><span href="#/Five#_idTextAnchor004" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOCitem"><span href="#/Six#_idTextAnchor005" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOCitem"><span href="#/Seven#_idTextAnchor006" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOCitem"><span href="#/Eight#_idTextAnchor007" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOCitem"><span href="#/Nine#_idTextAnchor008" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOCitem"><span href="#/Ten#_idTextAnchor009" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOCitem"><span href="#/Excerpt_from_The_Billionaire_Renegade_by_Catherine_Mann#_idTextAnchor010" title="Link target outside of Sample">Excerpt from <i>The Billionaire Renegade</i> by Catherine Mann</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?409a80a3